



















































































































import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import CustomerDetailActionBar from '@/web/components/customers/CustomerDetailActionBar.vue';
import HMDialog from '@/web/components/common/HMDialog.vue';
import moment from 'moment';

export default Vue.extend({
  name: 'CustomerDetailEvents',
  components: {
    CustomerDetailActionBar,
  },
  data() {
    return {
      search: '',
      attendanceTableFields: [
        {
          name: 'event_name',
          title: this.$t('CUSTOMERS.TABLE.ATTENDANCE_EVENT_NAME'),
          cssClass: 'h5',
        },
        {
          name: 'event_start_datetime',
          title: this.$t('CUSTOMERS.TABLE.EVENT_DATE'),
        },
        {
          name: 'registration_date',
          title: this.$t('CUSTOMERS.TABLE.REGISTRATION_DATE'),
        },
        {
          name: 'attendance_date',
          title: this.$t('CUSTOMERS.TABLE.ATTENDANCE_DATE'),
        },
        {
          name: 'status',
          title: this.$t('CUSTOMERS.TABLE.STATUS'),
        },
        {
          name: 'via_classcard',
          title: this.$t('CUSTOMERS.TABLE.CLASSCARD'),
        },
        {
          name: 'is_www_registration',
          title: this.$t('CUSTOMERS.TABLE.WWW_REGISTRATION'),
        },
        {
          name: 'options',
        },
      ],
      statusTexts: {
        'no-show': this.$t('EVENTS.LABEL.NO_SHOW'),
        registered: this.$t('EVENTS.LABEL.REGISTERED'),
        attended: this.$t('EVENTS.LABEL.ATTENDED'),
        recording: this.$t('EVENTS.LABEL.WATCHED_RECORDING'),
      },
    };
  },
  computed: {
    getUserId() {
      return parseInt(this.$route.params.id);
    },
    query() {
      return {
        studentId: this.getUserId,
        q: this.search,
      };
    },
  },
  methods: {
    async exportAttendancesCSV() {
      try {
        await this.$store.dispatch(
          'user/studentIdAttendancesExportToCSV',
          this.query
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'CSV Export failed',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    getStatus(event) {
      if (!event.event_end_datetime) return;
      if (event.reason === 'recording') return event.reason;

      if (event.attended) return 'attended';
      const hasEnded = moment().isAfter(event.event_end_datetime);
      if (hasEnded) return 'no-show';
      return 'registered';
    },
    getStatusText(data) {
      return this.statusTexts[this.getStatus(data)];
    },
    async refundRedemption(event) {
      const customerId = this.getUserId;
      const punchId = event.registration_punch_id;
      await this.$store.dispatch('event/refundCustomerPunch', {
        punchId,
        customerId,
      });
      this.$refs.eventAttendancesTable.refresh();
    },
    async customerMarkEventAttended(event) {
      try {
        this.$store.dispatch('event/customerMarkEventAttended', {
          eventId: event.id,
          eventRegistrationId: event.registration_id,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('EVENTS.LABEL.ATTENDANCE_MARKED_FAILED'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.$refs.eventAttendancesTable.refresh();
    },
    async coustomerRemoveEventAttendance(event) {
      try {
        this.$store.dispatch('event/coustomerRemoveEventAttendance', {
          eventId: event.id,
          eventRegistrationId: event.registration_id,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove event attendance',
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      }
      this.$refs.eventAttendancesTable.refresh();
    },
    confirmDeleteRegistration(event) {
      this.$modal.show(HMDialog, {
        title: this.$t('EVENTS.TITLE.REMOVE_EVENT_REGISTRATION'),
        text: this.$tc('EVENTS.TEXT.REMOVE_EVENT_REGISTRATION_CONFIRMATION'),
        confirmButton: this.$t('GENERAL.BUTTON.CONFIRM'),
        confirm: () => this.deleteRegistration(event),
      });
    },
    async deleteRegistration(event) {
      try {
        await this.$store.dispatch('event/removeEventRegistration', {
          eventId: event.id,
          registrationId: event.registration_id,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'NOTIFICATIONS.TEXT.EVENT_REGISTRATION_SUCCESSFULLY_REMOVED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to remove event registration',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.$refs.eventAttendancesTable.refresh();
    },
  },
});
